<template>
    <div class="app-main goods-list">

        
        <div class="top-bar">
            <el-input placeholder="输入商品名称" v-model="value" @change="search()" clearable style="width:300px;margin-right:20px;">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
        </div>
        <!-- 商品列表 -->
        <el-card shadow="hover">
            <el-table ref="multipleTable" :data="tableData"  height="600" >
                <el-table-column prop="shops_info.title" label="所属商家"  align="center"  show-overflow-tooltip></el-table-column>
                <el-table-column label="商品图片"  align="center">
                    <template slot-scope="scope">
                        <m-img v-if="scope.row.image_url" :src="scope.row.image_url" />
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="商品名称"  align="center"  min-width="160" show-overflow-tooltip></el-table-column>
                <el-table-column prop="name"  label="商品类型" align="center" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.goods_type == 2">食品类型</span>
                        <span v-else-if="scope.row.goods_type == 3">服务类型</span>
                        <span v-else>普通商品</span>
                    </template>
                </el-table-column>
                <el-table-column prop="created_at"  align="center" label="上架时间" min-width="140"></el-table-column>
                <el-table-column prop="totalMoney"  align="center" label="商品操作" >
                    <template slot-scope="scope">
                        <div class="table-btns">
                            <el-button  @click="getDetail(scope.row.id)" type="success" plain size="mini">查看详情</el-button>
                            <el-button  @click="goodsCheck(scope.row.id,2)" type="danger" plain size="mini">下架商品</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background @current-change="reloadData" :current-page.sync="page" layout="prev, pager, next, jumper" style="padding:15px" :total="total" :page-size="20" ></el-pagination>
        </el-card>

        <el-dialog title="商品详情" center :visible.sync="dialog" width="1230px" >

            <el-card class="m-bottom-4">
                <el-row class="m-bottom-2">
                    <el-col :span="2" class="label-left">中文名称</el-col>
                    <el-col :span="22" >
                        <el-input v-model="detail.name" readonly style="width:600px"></el-input>
                    </el-col>
                </el-row>
                <el-row class="m-bottom-2">
                    <el-col :span="2" class="label-left">英文名称</el-col>
                    <el-col :span="22" >
                        <el-input v-model="detail.name_en" readonly style="width:600px"></el-input>
                    </el-col>
                </el-row>
                <el-row >
                    <el-col :span="2" class="label-left"> 关 键 词 </el-col>
                    <el-col :span="22" >
                        <el-input v-model="detail.description" type="textarea" resize="none" readonly autosize  style="width:600px;"></el-input>
                    </el-col>
                </el-row>
            </el-card>

            <el-card class="m-bottom-4">
                <el-row>
                    <el-col :span="2" class="label-image">轮播图</el-col>
                    <el-col :span="22" >
                        <m-img v-for="(it, index) in detail.round_pic_url" :key="index" :src="it.url" />
                    </el-col>
                </el-row>
            </el-card>

            <el-card class="m-bottom-4">
                <el-row class="m-bottom-4">
                    <el-col :span="2" class="label-image">中文详情</el-col>
                    <el-col :span="22" >
                        <m-img v-for="(it, index) in detail.goods_details" :key="index" :src="it.url" :width="160" placement="top" />
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="2" class="label-image">英文详情</el-col>
                    <el-col :span="22" >
                        <m-img v-for="(it, index) in detail.goods_details_en" :key="index" :src="it.url" :width="160" placement="bottom" />
                    </el-col>
                </el-row>
            </el-card>

             <el-card class="m-bottom-4" style="overflow-y:auto">
                
                    <el-row class="m-bottom-4" v-if="detail.sku_list">
    
                        <div class="sku-items-head">
                            <div class="m-width-140"><span>规格 | SKU</span></div>
                            <div class="m-width-100"><span>销售价(C$)</span></div>
                            <div class="m-width-100"><span>预售价(C$)</span></div>
                            <div class="m-width-100"><span>代理价(C$)</span></div>
                            <div class="m-width-120"><span>重量(单位kg)</span></div>
                            <div class="m-width-100"><span>长(单位cm)</span></div>
                            <div class="m-width-100"><span>宽(单位cm)</span></div>
                            <div class="m-width-100"><span>高(单位cm)</span></div>
                            <div class="m-width-160"><span>条形码</span></div>
                            <div class="m-width-100"><span>变量图片</span></div>
                        </div>
                        <div class="sku-items-body" v-for="(it,index) in detail.sku_list" :key="index">
                            <div class="m-width-140">
                                <el-input v-model="it.attr_symbol_string"      size="small" readonly  style="margin-bottom:5px"></el-input>
                                <el-input v-model="it.attr_symbol_string_en"   size="small" readonly  ></el-input>
                            </div>
                            <div class="m-width-100"><el-input v-model="it.price"  readonly size="small"  ></el-input></div>
                            <div class="m-width-100"><el-input v-model="it.pre_sale_price" readonly  size="small"  ></el-input></div>
                            <div class="m-width-100"><el-input v-model="it.proxy_price" readonly  size="small"  ></el-input></div>
                            <div class="m-width-120"><el-input v-model="it.goods_weight" readonly size="small"  ></el-input></div>
                            <div class="m-width-100"><el-input v-model="it.goods_length" readonly  size="small"  ></el-input></div>
                            <div class="m-width-100"><el-input v-model="it.goods_width" readonly size="small"  ></el-input></div>
                            <div class="m-width-100"><el-input v-model="it.goods_height" readonly  size="small"  ></el-input></div>
                            <div class="m-width-160"><el-input v-model="it.barcode"   size="small" readonly ></el-input></div>
                            <div class="m-width-100" style="text-align:center">
                                <m-img  :src="it.sku_pic_url" placement="left" />
                            </div>
                        </div>
                    </el-row>  
                </el-card>

        </el-dialog>


    </div>
</template>



<script>
/* eslint-disable */
import { goods, detail, goods_status } from '@/api/merchant.js'

import MImg   from './../../../components/Image'

export default {
    components: { MImg },
    data() {
        return {
            value:'',
            tableData:[],
            table_load:false,
            total:0,
            page:1,

            dialog: false,
            detail: {},
        }
    },
    methods: {

        search() {
            this.page = 1
            this.getData()
        },
        getData(){
            this.tableData = [];
            let params = {
                page:this.page,
            }
            if(this.value != ""){
                params.search = this.value;
            }
            goods(1, params).then(res => {
                if(res){
                    this.tableData = res.data.data
                    this.total = res.data.total
                }else{
                    this.tableData = [];
                    // this.$message.error('Error')
                }
            })
        },
        reloadData(page){
            this.page = page;
            this.getData();
            this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
        },
        goodsEdit(row,flag){
            let params = {
                status:flag
            }
            goods_status(row.id,params).then(res => {
                if(res){
                    this.$message({message:res.msg,type:'success'})
                    this.getData()
                }else{
                    this.$message.error(res.msg)
                }
            }).catch(err => {
                this.table_load = false;
                console.log(err)
            })
        },


        // 显示详情

        getDetail(id){
            this.detail = {};
            detail(id).then(res => {
                if(res){
                    this.detail = res.data
                    this.dialog = true
                    res.data.sku_list.forEach(item => {
                        if(item.attr_symbol_string_en == ',') {
                            item.attr_symbol_string_en = ''
                        }
                    });
                }
            })
        },
        goodsCheck(id,flag) {
            let params = {
                status: flag,
            };
            goods_status(id, params)
                .then((res) => {
                if (res) {
                    this.$message({ message: res.msg, type: "success" });
                    this.getData();
                } else {
                    this.$message.error(res.msg);
                }
            });
        },


        
    },
    created(){
        this.getData();
    },
    activated() {
        this.getData()
    },
}
</script>

<style lang="less" scoped>
.label-left {
    min-width: 80px;
    height: 40px;
    line-height: 40px;
}
.label-image {
    min-width: 80px;
    height: 70px;
    line-height: 70px;
}
.sku-value {
        height: 40px;
        line-height: 40px;
        margin:20px 15px 0 0;
    }
    .sku-input {
        width: 150px;
        margin-right: 20px;
    }
    .m-width-100 {
        width: 90px;
    }
    .m-width-120 {
        width: 100px;
    }
    .m-width-140 {
        width: 130px;
    }
    .m-width-160 {
        width: 150px;
    }
    .sku-items-head {
        min-width: 1305px;
        display: flex;
        background: #f5f7fa;
        border: 1px solid #e8e8e8;
        >div {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 50px;
            padding: 0 8px;
            font-size: 15px;
            color: #8c939d;
            >span {
                display: inline-block;
                width: 100%;
                height: 36px;
                background: #fff;
                text-align: center;
                line-height: 36px;
                border-radius: 3px;
            }
        }
        
    }
    .sku-items-body {
        min-width: 1305px;
        display: flex;
        border: 1px solid #e8e8e8;
        border-top: none;
        >div {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 80px;
            padding: 0 8px;
            font-size: 15px;
            color: #8c939d;
        }
    }
    /deep/ .el-input--small .el-input__inner {
        text-align: center;
    }

</style>
